import React, { useState, useEffect } from "react";
// import {
//   AIRTABLE_PERSONAL_ACCESS_TOKEN,
//   AIRTABLE_BASE,
// } from "./config";
import { data } from './components/data';
import { Preloader, Preloader0 } from './uikit/Uikit';
import { getDataById } from './components/utils';

import usersData from './components/data/users.json';
import projectsData from './components/data/projects.json';
import videosData from './components/data/videos.json';
import metadataData from './components/data/metadata.json';
import metaDataTypesData from './components/data/metaDataTypes.json';
import playlistsData from './components/data/playlists.json';
import appsData from './components/data/apps.json';


// const Airtable = require("airtable");



// Airtable.configure({
//   endpointUrl: "https://api.airtable.com",
//   apiKey: AIRTABLE_PERSONAL_ACCESS_TOKEN,
// });
// const base = Airtable.base(AIRTABLE_BASE);

const Context = React.createContext();

function Provider({ children }) {





  // const [items, setItems] = useState([]);
  // const [items, setItems] = useState(itemsCached);


  const [categories, setCategories] = useState([]);
  // const [apps, setApps] = useState([]);


  // const [activeProjects, setActiveProjects] = useState([...data.projects.map(onePr => onePr['id'])]);
  // const [activeProjects, setActiveProjects] = useState(['gs', 'rc', 'ustoy']);
  const [activeUsers, setActiveUsers] = useState(['danny', 'misha', 'joe']);
  const [activeProjects, setActiveProjects] = useState(['gs']);
  const [activeDate, setActiveDate] = useState('10/27/2021');


  const getLocal = () => {
    let user = localStorage.getItem('user');
    return user ? JSON.parse(user) : {
      id: '',
      email: '',
      name: '',
      title: '',
      img: '',
    };
  };


  const defaultUser = 'recMJRYVP47ZOqcj3';

  const [user, setUser] = useState({
    id: '',
    email: '',
    img: '',
    title: '',
    name: '',
    img: '',
  });

  const [ready, setReady] = useState(true);







  const saveLocal = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
  };

  const setUserEmail = (email) => {
    console.log('email = ', email)
    let userNew = JSON.parse(JSON.stringify(user));
    userNew = {
      ...user,
      email: email
    }
    setUser(userNew)
    saveLocal(userNew)
  };





  // const [users, setUsers] = useState([...Users])
  // const [projects, setProjects] = useState([...Projects])
  // const [metadata, setMetadata] = useState([...Metadata])
  // const [videos, setVideos] = useState([...Videos])
  // const [metaDataTypes, setMetaDataTypes] = useState([...MetaDataTypes])
  // const [playlists, setPlaylists] = useState([...Playlists])



  const processUsers = (data) => {
    const d = data.records
      .filter(record => record.fields["active"])
      .map((record) => ({
        id: record['id'],
        uniq: record.fields['uniq'],
        active: record.fields['active'],
        name: record.fields['name'],
        email: record.fields['email'],
        img: record.fields['img'] ? record.fields['img'][0] : {},
        title: record.fields['title'],
        metadata: record.fields['metadata'] ? record.fields['metadata'] : [],
        videos: record.fields['videos'] ? record.fields['videos'] : [],
      }))
      console.log('processUsers = ', d);
      return d
  }


  const processProjects = (data) => {
    const d = data.records
      .filter(record => record.fields["active"])
      .map((record) => ({
        id: record['id'],
        uniq: record.fields['uniq'],
        title: record.fields['title'],
        img: record.fields['img'] ? record.fields['img'][0] : {},
        color: record.fields['color'],
        videos: record.fields['videos'] ? record.fields['videos'] : [],
        user: record.fields['user'] ? record.fields['user'][0] : {},
      }))
      console.log('processProjects = ', d);
      return d
  }

  const processVideos = (data) => {
    const d = data.records
      .filter(record => record.fields["active"])
      .map((record) => ({
        id: record['id'],
        uniq: record.fields['uniq'],
        url: record.fields['url'],
        mp4: record.fields['mp4'],
        img: record.fields['img'] ? record.fields['img'][0] : {},
        app: record.fields['app'] ? record.fields['app'][0] : {},
        date: record.fields['date'],
        length: record.fields['length'],
        title: record.fields['title'],
        user: record.fields['user'] ? record.fields['user'][0] : {},
        userImg: record.fields['userImg'] ? record.fields['userImg'][0] : [],
        metadata: record.fields['metadata'] ? record.fields['metadata'] : [],
        playlists: record.fields['playlists'] ? record.fields['playlists'] : [],
      }))
      console.log('processVideos = ', d);
      return d
  }

  const processMetadata = (data) => {     
    const d = data.records
      .filter(record => record.fields["active"])
      .map((record) => ({
        id: record['id'],
        uniq: record.fields['uniq'],
        author: record.fields['author'],
        metaTime: record.fields['metaTime'],
        shownByDefault: record.fields['shownByDefault'],

        type: record.fields['type'] ? record.fields['type'][0] : {},
        typeRef: record.fields['typeRef'] ? record.fields['typeRef'][0] : {},
        typeIcon: record.fields['typeIcon'] ? record.fields['typeIcon'][0] : {},
        typeColor: record.fields['typeColor'] ? record.fields['typeColor'][0] : {},
        typeTitle: record.fields['typeTitle'] ? record.fields['typeTitle'][0] : {},

        authorImg: record.fields['authorImg'] ? record.fields['authorImg'][0] : {},
        authorName: record.fields['authorName'],
        commentText: record.fields['commentText'],
        commentParentId: record.fields['commentParentId'],
        commentParentText: record.fields['commentParentText'],
        videoId: record.fields['videoId'] ? record.fields['videoId'][0] : '',
        videoThumb: record.fields['videoThumb'] ? record.fields['videoThumb'][0] : {},
      }))
      console.log('processMetadata = ', d);
      return d
  }
  const processMetaDataTypes = (data) => {
    const d = data.records
      .filter(record => record.fields["active"])
      .map((record) => ({
        id: record['id'],
        type: record.fields['type'],
        title: record.fields['title'],
        icon: record.fields['icon'],
        color: record.fields['color'],
        emoji: record.fields['emoji'],
      }))
      console.log('processMetaDataTypes = ', d);
      return d
  }
  const processApps = (data) => {
    return data.records
      .filter(record => record.fields["active"])
      .map((record) => ({
        id: record['id'],
        name: record.fields['name'],
        url: record.fields['url'] ? record.fields['url'][0] : {},
        title: record.fields['title'],
      }))
  }
  const processPlaylists = (data) => {
    const d = data.records
      .filter(record => record.fields["active"])
      .map((record) => ({
        id: record['id'],
        uniq: record.fields['uniq'],
        public: record.fields['public'],
        default: record.fields['default'],
        title: record.fields['title'],
        emoji: record.fields['emoji'],
        icon: record.fields['icon'],
        img: record.fields['img'] ? record.fields['img'][0] : {},
        color: record.fields['color'],
        videos: record.fields['videos'] ? record.fields['videos'] : [],
        user: record.fields['user'] ? record.fields['user'][0] : {},
      }))
      console.log('processPlaylists = ', d);
      return d
  }


  const users = processUsers(usersData);
  const projects = processProjects(projectsData);
  const videos = processVideos(videosData);
  const metadata = processMetadata(metadataData);
  const metaDataTypes = processMetaDataTypes(metaDataTypesData);
  const playlists = processPlaylists(playlistsData);
  const apps = processApps(appsData);



  // useEffect(() => {
  //   if (!users.length) {
  //     base("Users")
  //       .select({
  //         maxRecords: 100,
  //         // sort: [{ field: "importance", direction: "desc" }],
  //       })
  //       .eachPage(function page(partialRecords, fetchNextPage) {
  //         setUsers([
  //             ...users,
  //             ...partialRecords
  //               .filter(record => record.fields["active"))
  //               .map((record) => ({
  //                 id: record['id'],
  //                 uniq: record.fields['uniq'],
  //                 active: record.fields['active'],
  //                 name: record.fields['name'],
  //                 email: record.fields['email'],
  //                 img: record.fields['img'] ? record.fields['img'][0] : {},
  //                 title: record.fields['title'],
  //                 metadata: record.fields['metadata'] ? record.fields['metadata'] : [],
  //                 videos: record.fields['videos'] ? record.fields['videos'] : [],
  //               })),
  //           ]);
  //           // partialRecords.forEach(function(record) {
  //           //   console.log('Retrieved', partialRecords.fields['img_url'));
  //           // });
  //           fetchNextPage();
  //         },
  //         function done(err) {
  //           if (err) {
  //             console.error(err);
  //             return;
  //           } else {
  //           }
  //         }
  //       );
  //   }

  //   if (users.length && !user['id']) {
  //     setUser({
  //       ...getUserDataById(defaultUser)
  //     })
  //   }

  // }, [users]);


  // useEffect(() => {
  //   if (!projects.length) {
  //     base("Projects")
  //       .select({
  //         maxRecords: 100,
  //         // sort: [{ field: "importance", direction: "desc" }],
  //       })
  //       .eachPage(function page(partialRecords, fetchNextPage) {
  //         setProjects([
  //             ...projects,
  //             ...partialRecords
  //               .filter(record => record.fields["active"))
  //               .map((record) => ({
  //                 id: record['id'],
  //                 uniq: record.fields['uniq'],
  //                 title: record.fields['title'],
  //                 img: record.fields['img'] ? record.fields['img'][0] : {},
  //                 color: record.fields['color'],
  //                 videos: record.fields['videos'] ? record.fields['videos'] : [],
  //                 user: record.fields['user'] ? record.fields['user'][0] : {},
  //               })),
  //           ]);
  //           // partialRecords.forEach(function(record) {
  //           //   console.log('Retrieved', partialRecords.fields['img_url'));
  //           // });
  //           fetchNextPage();
  //         },
  //         function done(err) {
  //           if (err) {
  //             console.error(err);
  //             return;
  //           }
  //         }
  //       );
  //   }
  // }, [projects]);

  // useEffect(() => {
  //   if (!playlists.length) {
  //     base("Playlists")
  //       .select({
  //         maxRecords: 100,
  //         // sort: [{ field: "importance", direction: "desc" }],
  //       })
  //       .eachPage(function page(partialRecords, fetchNextPage) {
  //         setPlaylists([
  //             ...playlists,
  //             ...partialRecords
  //               .filter(record => record.fields["active"))
  //               .map((record) => ({
  //                 id: record['id'],
  //                 uniq: record.fields['uniq'],
  //                 public: record.fields['public'],
  //                 default: record.fields['default'],
  //                 title: record.fields['title'],
  //                 emoji: record.fields['emoji'],
  //                 icon: record.fields['icon'],
  //                 img: record.fields['img'] ? record.fields['img'][0] : {},
  //                 color: record.fields['color'],
  //                 videos: record.fields['videos'] ? record.fields['videos'] : [],
  //                 user: record.fields['user'] ? record.fields['user'][0] : {},
  //               })),
  //           ]);
  //           // partialRecords.forEach(function(record) {
  //           //   console.log('Retrieved', partialRecords.fields['img_url'));
  //           // });
  //           fetchNextPage();
  //         },
  //         function done(err) {
  //           if (err) {
  //             console.error(err);
  //             return;
  //           }
  //         }
  //       );
  //   }
  // }, [playlists]);

  // useEffect(() => {
  //   if (!videos.length) {
  //     base("Videos")
  //       .select({
  //         maxRecords: 100,
  //         // sort: [{ field: "importance", direction: "desc" }],
  //       })
  //       .eachPage(function page(partialRecords, fetchNextPage) {
  //         setVideos([
  //             ...videos,
  //             ...partialRecords
  //               .filter(record => record.fields["active"))
  //               .map((record) => ({
  //                 id: record['id'],
  //                 uniq: record.fields['uniq'],
  //                 url: record.fields['url'],
  //                 mp4: record.fields['mp4'],
  //                 img: record.fields['img'] ? record.fields['img'][0] : {},
  //                 app: record.fields['app'] ? record.fields['app'][0] : {},
  //                 date: record.fields['date'],
  //                 length: record.fields['length'],
  //                 title: record.fields['title'],
  //                 user: record.fields['user'] ? record.fields['user'][0] : {},
  //                 userImg: record.fields['userImg'] ? record.fields['userImg'][0] : [],
  //                 metadata: record.fields['metadata'] ? record.fields['metadata'] : [],
  //                 playlists: record.fields['playlists'] ? record.fields['playlists'] : [],
  //               })),
  //           ]);
  //           // partialRecords.forEach(function(record) {
  //           //   console.log('Retrieved', partialRecords.fields['img_url'));
  //           // });
  //           fetchNextPage();
  //         },
  //         function done(err) {
  //           if (err) {
  //             console.error(err);
  //             return;
  //           }
  //         }
  //       );
  //   }
  // }, [videos]);


  // useEffect(() => {
  //   if (!apps.length) {
  //     base("Apps")
  //       .select({
  //         maxRecords: 100,
  //         // sort: [{ field: "importance", direction: "desc" }],
  //       })
  //       .eachPage(function page(partialRecords, fetchNextPage) {
  //         setApps([
  //             ...apps,
  //             ...partialRecords
  //               .filter(record => record.fields["active"))
  //               .map((record) => ({
  //                 id: record['id'],
  //                 name: record.fields['name'],
  //                 url: record.fields['url'] ? record.fields['url'][0] : {},
  //                 title: record.fields['title'],
  //               })),
  //           ]);
  //           // partialRecords.forEach(function(record) {
  //           //   console.log('Retrieved', partialRecords.fields['img_url'));
  //           // });
  //           fetchNextPage();
  //         },
  //         function done(err) {
  //           if (err) {
  //             console.error(err);
  //             return;
  //           }
  //         }
  //       );
  //   }
  // }, [apps]);


  // useEffect(() => {
  //   if (!metadata.length) {
  //     base("Metadata")
  //       .select({
  //         maxRecords: 100,
  //         view: "DONTCHANGE",
  //         // sort: [{ field: "importance", direction: "desc" }],
  //       })
  //       .eachPage(function page(partialRecords, fetchNextPage) {
  //         setMetadata([
  //             ...metadata,
  //             ...partialRecords
  //               .filter(record => record.fields["active"))
  //               .map((record) => ({
  //                 id: record['id'],
  //                 uniq: record.fields['uniq'],
  //                 author: record.fields['author'],
  //                 metaTime: record.fields['metaTime'],
  //                 shownByDefault: record.fields['shownByDefault'],

  //                 type: record.fields['type'] ? record.fields['type'][0] : {},
  //                 typeRef: record.fields['typeRef'] ? record.fields['typeRef'][0] : {},
  //                 typeIcon: record.fields['typeIcon'] ? record.fields['typeIcon'][0] : {},
  //                 typeColor: record.fields['typeColor'] ? record.fields['typeColor'][0] : {},
  //                 typeTitle: record.fields['typeTitle'] ? record.fields['typeTitle'][0] : {},


  //                 authorImg: record.fields['authorImg'] ? record.fields['authorImg'][0] : {},
  //                 authorName: record.fields['authorName'],
  //                 commentText: record.fields['commentText'],
  //                 commentParentId: record.fields['commentParentId'],
  //                 commentParentText: record.fields['commentParentText'],
  //                 videoId: record.fields['videoId'] ? record.fields['videoId'][0] : '',
  //                 videoThumb: record.fields['videoThumb'] ? record.fields['videoThumb'][0] : {},
  //               })),
  //           ]);
  //           // partialRecords.forEach(function(record) {
  //           //   console.log('Retrieved', partialRecords.fields['img_url'));
  //           // });
  //           fetchNextPage();
  //         },
  //         function done(err) {
  //           if (err) {
  //             console.error(err);
  //             return;
  //           }
  //         }
  //       );
  //   }
  // }, [metadata]);



  // useEffect(() => {
  //   if (!metaDataTypes.length) {
  //     base("MetadataTypes")
  //       .select({
  //         maxRecords: 100,
  //         view: 'Grid view',
  //         // view: "DONTCHANGE",
  //         sort: [{ field: "importance", direction: "desc" }],
  //       })
  //       .eachPage(function page(partialRecords, fetchNextPage) {
  //         setMetaDataTypes([
  //             ...metaDataTypes,
  //             ...partialRecords
  //             .filter(record => record.fields["active"))
  //             .map((record) => ({
  //               id: record['id'],
  //               type: record.fields['type'],
  //               title: record.fields['title'],
  //               icon: record.fields['icon'],
  //               color: record.fields['color'],
  //               emoji: record.fields['emoji'],
  //             })),
  //           ]);
  //           fetchNextPage();
  //         },
  //         function done(err) {
  //           if (err) {
  //             console.error(err);
  //             return;
  //           }
  //         }
  //       );
  //   }
  // }, [metaDataTypes]);



  // useEffect(() => {
  //   if (
  //       users.length &&
  //       videos.length &&
  //       metadata.length &&
  //       projects.length &&
  //       metaDataTypes.length &&
  //       apps.length,
  //       playlists.length
  //     ) {
  //     setReady(true)
  //   }
  // }, [
  //   users,
  //   videos,
  //   metadata,
  //   projects,
  //   metaDataTypes,
  //   apps,
  //   playlists
  // ])



  // const saveToLocal = (alert) => {
  //   let data = JSON.stringify({
  //     stacks: stacks,
  //   });
  //   // .replace('value:false,', 'defaultValue:false,')
  //   // .replace('value:true,', 'defaultValue:true,');
  //   localStorage.setItem("gs", data);
  //   if (alert)
  //     addToast("Saved Successfully", {
  //       appearance: "success",
  //       autoDismiss: true,
  //       autoDismissTimeout: 500,
  //     });
  // };

  const getFromLocal = () => {
    let data = localStorage.getItem("gs");
    return Boolean(data) ? JSON.parse(data) : null;
  };





  const getUserDataById = (userId) => {
    let user = users.filter(oneUser => oneUser['id'] === userId);
    let blankUser = {
      id: '-',
      name: '-',
      title: '-',
      ava: '',
      log: []
    }
    return user.length ? user[0] : blankUser;
  };


  const getUsersForProjects = (date, activeProjects = [],) => {
    // activeUsers
    let users = []
    console.log('data[users] = ', data['users']);
    data['users'].forEach(oneUser => {
      if (!activeUsers.includes (oneUser['id'])) return
      // let checkDate = date === oneUser['log']['date'];
      let userLogForDay = oneUser['log'].filter(oneLogEntry => oneLogEntry['date'] === date && activeProjects.includes(oneLogEntry['project']))
      let userFiltered = JSON.parse(JSON.stringify(oneUser));
      userFiltered['log'] = userLogForDay;
      if (userLogForDay.length) users.push(userFiltered)
    })
    return users
  }


  const getPlaylistIdFromName = (playlistName) => {
    let id = playlists.filter(p=> p['uniq'] === playlistName);
    // console.log('id[0][id] = ', id[0]['id']);
    return id.length ? id[0]['id'] : ''
  }



  const setNewDate = (newDate) => setActiveDate(newDate)

  return (
    <Context.Provider
      value={{
        ready,
        user: {
          ...user
          // email: user['email'],
        },
        state: {
          activeUsers,
          activeProjects,
          activeDate,
        },
        data: {
          playlists: playlists,
          metaDataTypes: metaDataTypes,
          users: users,
          projects: projects,
          videos: videos,
          metadata: metadata,
          apps: apps
        },
        handles: {
          getUserDataById,
          getUsersForProjects,
          setNewDate,
          setActiveUsers,
          setActiveProjects,
          getPlaylistIdFromName
        }

      }}
    >

      {!ready && <Preloader0><Preloader width={120} height={120}/></Preloader0>}
      {children}
    </Context.Provider>
  );
}

const Consumer = Context.Consumer;

export { Context, Provider, Consumer };
